/**
 * Query keys del dominio de autenticación.
 *
 * Centralizadas para que el provider y los hooks de login/logout invaliden o
 * lean exactamente la misma key (`docs/frontend_conventions.md`, Datos).
 */

/** Key de la identidad hidratada (`GET /auth/me`). */
export const AUTH_ME_QUERY_KEY = ["auth", "me"] as const;
